import jwt_decode from "jwt-decode";

const checkRole = () => {
    return jwt_decode(localStorage.authToken).auth
}

export default checkRole